import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";
import { Textfit } from "react-textfit";
import { appMetadataList } from "src/pods/list";
import { ToolListItem } from "src/pods/toolkitData/components/EditableSetup";
import logEvent from "src/utils/logEvent";

type DirectionsDisplayProps = {
  title?: string;
  list?: ToolListItem[];
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class DirectionsDisplay extends React.Component<DirectionsDisplayProps> {
  componentDidMount() {
    logEvent({
      eventName: "directions.result.open",
    });
  }

  componentWillUnmount() {
    logEvent({
      eventName: "directions.result.close",
    });
  }

  render() {
    const { title, list } = this.props;
    return (
      <article sx={cardStyle}>
        <Textfit sx={directionsDisplayTextfitStyle}>
          {title && <h1 sx={titleStyle}>{title}</h1>}
          <ol sx={listStyle}>
            {list &&
              list.map((item, idx) => (
                <li key={idx} sx={itemStyle}>
                  <span sx={itemCountStyle()}>{idx + 1}</span>
                  <p sx={itemTextStyle}>{item.text}</p>
                </li>
              ))}
          </ol>
        </Textfit>
      </article>
    );
  }
}

const directionsDisplayTextfitStyle: ThemeUIStyleObject = {
  display: "flex",
  flex: "1 1 0%",
};

const cardStyle: ThemeUIStyleObject = {
  padding: RAW_cssValue("56px"),
  borderRadius: "dt_radius_s",
  textAlign: "left",
  backgroundColor: RAW_cssValue("#fff"),
  color: RAW_cssValue("#3e425d"),
  /* not great; this couples this view to a parent that is a flex parent */
  alignSelf: "stretch",
  flex: "1 1 0%",
  display: "flex",
  justifyContent: "center",
  margin: RAW_cssValue("80px"),
};

const titleStyle: ThemeUIStyleObject = {
  width: "100%",
  margin: RAW_cssValue("0 auto"),
  padding: RAW_cssValue("0"),
  fontSize: "2em",
  fontWeight: "800",
  textAlign: "center",
};

const listStyle: ThemeUIStyleObject = {
  margin: RAW_cssValue("0"),
  padding: RAW_cssValue("0"),
  listStyle: "none",
};

const itemStyle: ThemeUIStyleObject = {
  margin: RAW_cssValue("1em 0"),
  display: "flex",
};

const itemCountStyle = (): ThemeUIStyleObject => ({
  display: "inline-block",
  minWidth: "1.5em",
  height: "1.5em",
  marginRight: RAW_cssValue("1em"),
  border: RAW_cssValue(`0.125em solid ${appMetadataList().backgroundColor}`),
  borderRadius: "dt_radius_s",
  textAlign: "center",
  verticalAlign: "top",
  lineHeight: "1.2em",
  fontSize: "1em",
  fontWeight: "800",
  backgroundColor: RAW_cssValue("#fff"),
  color: RAW_cssValue(appMetadataList().backgroundColor),
});

const itemTextStyle: ThemeUIStyleObject = {
  display: "inline-block",
  width: "",
  margin: RAW_cssValue("0"),
  padding: RAW_cssValue("0"),
  textAlign: "left",
  fontSize: "1.4em",
  fontWeight: "600",
  flex: "1 1 0%",
};
